/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressDto } from './CreateAddressDto';
import {
    CreateAddressDtoFromJSON,
    CreateAddressDtoFromJSONTyped,
    CreateAddressDtoToJSON,
    CreateAddressDtoToJSONTyped,
} from './CreateAddressDto';

/**
 * Generic contact with entity information and person details
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
    /**
     * Name of the entity (bank, broker, etc.)
     * @type {string}
     * @memberof ContactDto
     */
    entityName: string;
    /**
     * 
     * @type {CreateAddressDto}
     * @memberof ContactDto
     */
    entityAddress: CreateAddressDto;
    /**
     * Last name of the contact person
     * @type {string}
     * @memberof ContactDto
     */
    lastName?: string;
    /**
     * First name of the contact person
     * @type {string}
     * @memberof ContactDto
     */
    firstName?: string;
    /**
     * Phone number of the contact person
     * @type {string}
     * @memberof ContactDto
     */
    phone?: string;
    /**
     * Email of the contact person
     * @type {string}
     * @memberof ContactDto
     */
    email?: string;
}

/**
 * Check if a given object implements the ContactDto interface.
 */
export function instanceOfContactDto(value: object): value is ContactDto {
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('entityAddress' in value) || value['entityAddress'] === undefined) return false;
    return true;
}

export function ContactDtoFromJSON(json: any): ContactDto {
    return ContactDtoFromJSONTyped(json, false);
}

export function ContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'entityName': json['entityName'],
        'entityAddress': CreateAddressDtoFromJSON(json['entityAddress']),
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ContactDtoToJSON(json: any): ContactDto {
    return ContactDtoToJSONTyped(json, false);
}

export function ContactDtoToJSONTyped(value?: ContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityName': value['entityName'],
        'entityAddress': CreateAddressDtoToJSON(value['entityAddress']),
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'phone': value['phone'],
        'email': value['email'],
    };
}

